import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { LayoutsModule } from './common/layouts/layouts.module';
import { RouterModule } from '@angular/router';

import { ROUTES } from './app.routes';
import { HomeModule } from './views/home/home.module';
import { HotelierPermitsModule } from './views/hoteliers-permits/hotelierpermits.module';
import { VoucherCovidModule } from './views/voucher-covid/voucher-covid.module';
import { VoucherModule } from './views/voucher/voucher.module';
import { TargheModule } from './views/targhe/targhe.module';
import { AtbPayModule } from './views/atb-pay/atb-pay.module';
import { MobileAppModule } from './views/mobile-app/mobile-app.module';
import { httpFactory }  from './http.factory';
import { Http, XHRBackend, RequestOptions, HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AtbHomeService } from './services/atbHome.service';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';




@NgModule({
  declarations: [
    AppComponent,

  ],
  imports: [
    BrowserModule,
    LayoutsModule,
    HomeModule,
    HotelierPermitsModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    TargheModule,
    VoucherCovidModule,
    VoucherModule,
    AtbPayModule,

    MobileAppModule,

   // NgbModule.forRoot(),
    RouterModule.forRoot(ROUTES, {useHash: true}),
    NgbModule.forRoot(),
    ModalModule.forRoot(),
    TimepickerModule.forRoot(),
    PaginationModule.forRoot()

  ],
  providers: [
    {
    provide: Http,
    useFactory: httpFactory,
    deps: [XHRBackend, RequestOptions]
    },
    {
    provide: LocationStrategy,
    useClass: HashLocationStrategy
    },
    AtbHomeService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts